import { IPerk } from '../types';
import { getConfig } from '../utils/config';
import ResourceManager from './resource.manager';

const config = getConfig();

class OutsourcingService extends ResourceManager {
	async addOutsourcingRequest(outsourcingRequest): Promise<IPerk[] | null> {
		return await this.postResource(config.URIs.outsourcing_uri, outsourcingRequest);
	}
}

export default new OutsourcingService();
